import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './themeColor.scss';
import SignUp from './SignUp';
import LoginCard from './Login';
import ForgotPassword from './ForgotPassword';
import VerifyOTP from "./VerifyOTP";

interface BaseAuthProps {
    routeType?: 'login' | 'signup' | 'forgot-password' | 'active-account';
}

const BaseAuth: React.FC<BaseAuthProps> = ({ routeType = 'signup' }) => {
    return (
        <div className="w-full min-h-screen flex flex-col auth-wrapper bg-white" style={{ backgroundImage: "var(--color-linear-gradient)" }}>
            <div className="w-full h-screen flex flex-row justify-center items-center px-4 py-6 overflow-hidden">
                <div className="hidden lg:flex lg:w-1/2 xl:w-5/12 items-center justify-center py-4">
                    <img src="/images/login_bg.svg" alt="Background" className="w-3/4 max-w-md" />
                </div>
                <div className="w-full lg:w-1/2 xl:w-7/12 max-w-xl mx-auto px-4 py-4">
                    <ToastContainer />
                    {routeType === 'signup' && <SignUp />}
                    {routeType === 'login' && <LoginCard />}
                    {routeType === 'forgot-password' && <ForgotPassword />}
                    {routeType === 'active-account' && <VerifyOTP />}
                </div>
            </div>
        </div>
    );
};

export default BaseAuth;